const typography = {
    mainFont: "Tondo Corp" || "Open Sans" || "Helvetica" || "sans-serif",
}

export default typography